import axios from "axios";
import { IAnswer } from "../Interfaces";

const SHEET_ID = process.env.REACT_APP_GOOGLE_SHEET_ID as string;
const BASE_URL = process.env.REACT_APP_GOOGLE_SHEET_BASE_URL as string;

const header = (token: string | null) => {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const checkUserSheet = async (token: string | null, sheetName: string) => {
  const response = await axios.get(`${BASE_URL}${SHEET_ID}`, {
    headers: header(token),
  });

  const sheetExist: boolean = response.data.sheets.some(
    (sheet: { properties: { title: string } }) => {
      return sheet.properties.title === sheetName;
    }
  );

  return sheetExist;
};

const createUserSheet = (token: string | null, sheetName: string) => {
  fetch(
    `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}:batchUpdate`,
    {
      method: "POST",
      headers: header(token),
      body: JSON.stringify({
        requests: [
          {
            addSheet: {
              properties: {
                title: sheetName,
                gridProperties: {
                  rowCount: 150,
                  columnCount: 11,
                },
              },
            },
          },
        ],
      }),
    }
  ).then((response) => {
    return response;
  });
};

const updateSheetValues = async (
  token: string | null,
  sheet: string,
  data: IAnswer
) => {
  const datasToSend = await fetch(
    `${BASE_URL}${SHEET_ID}/values/${sheet}:append?valueInputOption=USER_ENTERED`,
    {
      method: "POST",
      headers: header(token),
      body: JSON.stringify({
        range: sheet,
        majorDimension: "ROWS",
        values: [data],
      }),
    }
  );
  const statusUpdate = await datasToSend.status;

  return statusUpdate;
};

const getSheetValues = async (
  token: string | null,
  sheet: string | null,
  range: string | null
) => {
  try {
    const response = await axios.get(
      `${BASE_URL}${SHEET_ID}/values/${sheet}!${range}`,
      {
        headers: header(token),
      }
    );

    return response.data.values;
  } catch (error) {
    // if (error) {
    //   window.location.href = "/";
    // }
  }
};

export {
  updateSheetValues,
  getSheetValues,
  createUserSheet,
  checkUserSheet,
};
